import LoaderFull from '@space-shell/common/components/loaderFull'

import { withAuth } from '@space-shell/common/hocs/withAuth'

const RenewPage = () => <LoaderFull />

export default withAuth(RenewPage)
